import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class Pagination extends Component {
  render() {
  const { rowsPerPage, totalCount, lastIndex, startIndex, t } = this.props;
  const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalCount / rowsPerPage); i++) {
      pageNumbers.push(i);
    }

  return (
    <nav>
      <ul className='pagination'>
       <div className="pagination-ge-wrapper">
         <div className="data-list">{this.props.children}</div>
         <div className="page-count-and-current-pg-info-container">
           <div className="current-pg-info">
             <span className="current-pg-info__text">
               {startIndex+1}-{lastIndex > totalCount ? totalCount :lastIndex} {t('of')} {totalCount} {t('facilities')}
             </span>
           </div>
              <ReactPaginate
                breakLabel="..."
                nextLabel= {<span>{t('Next')}<FontAwesomeIcon icon = 'chevron-right' style = {{marginLeft:'8px',filter: 'brightness(115%)'}}/></span>}
                onPageChange={this.props.paginate}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                pageCount={pageNumbers.length}
                previousLabel={<span><FontAwesomeIcon icon = 'chevron-left' style = {{marginRight:'8px',filter: 'brightness(115%)'}}/>{t('Previous')}</span>} 
                previousClassName = 'prev-btn nav-btn'
                nextClassName = 'next-btn nav-btn'
                containerClassName={"page-counting-container"}
                activeClassName = 'active-pg'
                pageClassName = 'pg-number'
                breakClassName = 'pg-number'
                renderOnZeroPageCount={null}
                disabledClassName = 'disabled-btn-nav'
              />
         </div>
       </div>
     
      </ul>
    </nav>
  );
}
}

export default withTranslation()(Pagination);
